import type { JSX } from 'react';

import { Text } from '@change/ds-core-ui/next';

import { TranslateHtml } from '@change-corgi/core/react/i18n';

export function Header(): JSX.Element {
	return (
		<Text as="div" className="text-typography-weak mb-6" id="abuse-modal-form-description">
			{/* TODO: replace links using <Link>? */}
			<TranslateHtml
				value="fe.components.petition_report_abuse.form_description"
				replacements={{ tosUrl: '/policies/terms-of-service', cgUrl: '/policies/community' }}
			/>
		</Text>
	);
}
